import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CreateStatusType } from '@state/utils/models';
import { MatterDispatch } from '@state/matter';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Brokerage } from '@models/matter';
import { TestHooks } from './create-brokerage-side-form.hooks';

@UntilDestroy()
@Component({
	selector: 'app-create-brokerage-side-form',
	templateUrl: './create-brokerage-side-form.component.html',
	standalone: false,
})
export class CreateBrokerageSideFormComponent {
	testHooks = TestHooks;
	@Input() name;
	@Input() isClient;
	@Input() createStatusType = CreateStatusType;
	@Input() brokerage: Brokerage;

	@Output() onCreate = new EventEmitter();
	@Output() onCancel = new EventEmitter();

	@SelectSnapshot(SelectedMatter.id) saleId;
	@SelectSnapshot(SelectedMatter.matterFileType) matterFileType;

	constructor(private matterDispatch: MatterDispatch) {}

	createBrokerage = (brokerage: Brokerage) =>
		this.matterDispatch.CreateBrokerage(
			this.saleId,
			brokerage,
			this.isClient,
			this.matterFileType,
		);

	onSubmit(event) {
		this.createBrokerage(event);
		this.onCreate.emit(event);
	}

	_onCancel() {
		this.onCancel.emit();
	}
}

export interface CreateOrUpdateBrokerageModel {
	name: string;
	isClient: boolean;
	brokerage: Brokerage;
}
